import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@radix-ui/react-tooltip";
import { HelpCircle } from "lucide-react";
import React from "react";

interface QuestionMarkTooltipProps {
  content: string;
  size?: number;
}

const QuestionMarkTooltip: React.FC<QuestionMarkTooltipProps> = ({ content, size = 16 }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="inline-flex items-center justify-center rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            type="button"
            aria-label="More information"
          >
            <HelpCircle size={size} className="text-muted-foreground hover:text-foreground transition-colors" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs bg-black text-white p-2 text-xs rounded-md shadow-lg">
          <p>{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default QuestionMarkTooltip;

// Usage example:
// <QuestionMarkTooltip content="This is helpful information about this field." />
